import {
  REACT_APP_TIMELINE_API_URL,
  REACT_APP_TIMELINE_API_KEY,
} from 'src/utils/constants';


export const getInvestorDocumentsPreview= async (uuid,UserToken)=> {
  try {
    const url = `${REACT_APP_TIMELINE_API_URL}/muniments/${uuid}/preview`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': REACT_APP_TIMELINE_API_KEY,
        'x-token': UserToken
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    
    return data.file;
  } catch (error) {
    console.error('Error al obtener documentos del inversor:', error);
    throw error;
  }
};

